import React from 'react'

const BluetoothInterduction = () => {
  return (
    <>
        <section id="first" className="portfolio-s about bg2">
  <div className="container">
    <div className="section-title">
      <br />
      <h2 className="animated fadeInDown">Introduction</h2>
      <div className="bar" />
      <div className="row">
        <div className="col-lg-12">
          <div className=" cd-intro-content bouncy shadow p-4 animated swing">
            <div className="row">
              <div className="col-md-8">
                <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                  Listen &amp; Be Heard
                </h3>
                <p className="pl-md-4 text-justify">
                  This application is a mobile application where user can
                  connect with the one or more Bluetooth device. In this one
                  will be input device and another will be device (Total 2
                  output devices will be connected at a time). Once the device
                  is connected or play then user can record his voice. User will
                  also have the 7 days free subscription after that user can
                  take the subscription and user the application without any
                  interference.{" "}
                </p>
                <p className="pl-md-4 text-justify">
                  When the audio is played then user can increase the volume of
                  the audio. User can also play his or her recorded audio. The
                  Volume action will be the default volume of the system. When
                  user changes the volume then it will affect the default system
                  volume.We have two modes: (a) lecture mode and (b) karaoke
                  mode both modes have the option to record. In Karaoke mode the
                  user will play either an audio file (for the music track or a
                  video file that has music + lyrics (local or web).
                </p>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="video-responsive mt-5">
                  <video
                    className="video-fluid z-depth-1"
                    autoPlay=""
                    loop=""
                    controls=""
                    muted=""
                  >
                    <source
                      src="assets/img/Bluetooth/hear.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default BluetoothInterduction